import { AnimatedNumber } from "./components/customComponent/countUpFunction";

export const detailsData = [
    {
        id: 1,
        heading: "funding",
        data:  <AnimatedNumber start={0} end={22000000} duration={2000} suffixType="million" /> ,
        description: "our yearly funding"
    },
    {
        id: 2,
        heading: "founded",
        data:  <AnimatedNumber start={1000} end={2025} duration={1000} suffixType="none" />,
        description: "Running Up!"
    },
    {
        id: 3,
        heading: "Headquartres",
        data: "chennai, IND",
        description: "madipakkam!"
    },
    {
        id: 4,
        heading: "funding",
        data: "In the news",
        description: "our yearly funding"
    },
    {
        id: 5,
        heading: "founded",
        data: "Data base",
        description: "Running Up!"
    },
    {
        id: 6,
        heading: "Headquartres",
        data: "values",
        description: "madipakkam!"
    }
]